import type Vue from 'vue';
import type { ThirdPartyPlugin } from '../types';
import { load } from './script';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element | Vue | Vue[] | Element[], flag: boolean) => void;
    };
  }
}

const trustpilotPlugin: ThirdPartyPlugin = () => {
  return {
    load: () => {
      load();
      return Promise.resolve();
    },
  };
};

export default trustpilotPlugin;
